import { render, staticRenderFns } from "./audit-form.vue?vue&type=template&id=d1637d08&scoped=true"
import script from "./audit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./audit-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./audit-form.vue?vue&type=style&index=0&id=d1637d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1637d08",
  null
  
)

export default component.exports